import React from 'react';

import Qualifications from 'components/Qualifications';

const ReservationQualifications = ({ id }) => {
  return <Qualifications id={id} type="Reservation" />;
};

export default ReservationQualifications;
